import React from "react";
import { Link } from "react-router-dom";
import Title from "../../components/atoms/Title";
import ButtonT from "../../components/atoms/ButtonT";
import Button from "../../components/atoms/Button";
const ModelsDetailHeader = ({ deleted, editto,id, Json, name }) => {
  return (
    <div className="flex flex-row justify-between items-center h-10 ">
      <div className="flex flex-row">
        <Title text={`جزئیات سفارش “${name}”`} />
      </div>

      <div className="flex flex-row gap-3.5">
        <Button
          text={"فایل نمونه JSON"}
          borderBlue="border-blue border-1"
          textcolor={" text-dark-blue-200"}
          onClick={Json}
        />
        <Link to={`${editto}?id=${id}`}>
          <Button
            text={"ویرایش مدل"}
            borderBlue="border-blue border-1"
            textcolor={" text-dark-blue-200"}
          />
        </Link>

        <Button
          text={"حذف مدل"}
          borderBlue="border-red border-1"
          textcolor={"text-red "}
          onClick={deleted}
        />
        <ButtonT text={"برگشت به لیست"} path={"/admin/device/models"} link={true} />
      </div>
    </div>
  );
};

export default ModelsDetailHeader;
